import React from 'react';
import ReactDOM from 'react-dom/client';
// import './css/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// 只在开发环境使用 StrictMode，避免生产环境中的重复调用
const app = <App />;
const appWithStrictMode = <React.StrictMode>{app}</React.StrictMode>;

root.render(process.env.NODE_ENV === 'production' ? app : appWithStrictMode);
